// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationOverlay_wrapper__TLnBm","paper":"NavigationOverlay_paper__p3i25","slideUpAppearance":"NavigationOverlay_slideUpAppearance__A5ciE"};